import { BooleanInput, coerceBooleanProperty } from "@angular/cdk/coercion";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { LocalComponentStore } from "@dtm-frontend/shared/utils";
import { UntilDestroy } from "@ngneat/until-destroy";

interface QuillViewerComponentState {
    content: string;
    shouldSanitizeContent: boolean;
}

@UntilDestroy()
@Component({
    selector: "dtm-ui-quill-viewer",
    templateUrl: "./quill-viewer.component.html",
    styleUrls: ["./quill-viewer.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
})
export class QuillViewerComponent {
    @Input({ required: true }) public set content(value: string) {
        this.localStore.patchState({ content: value });
    }

    @Input() public set shouldSanitizeContent(value: BooleanInput) {
        this.localStore.patchState({ shouldSanitizeContent: coerceBooleanProperty(value) });
    }

    protected content$ = this.localStore.selectByKey("content");
    protected shouldSanitizeContent$ = this.localStore.selectByKey("shouldSanitizeContent");

    constructor(private readonly localStore: LocalComponentStore<QuillViewerComponentState>) {
        localStore.setState({
            content: "",
            shouldSanitizeContent: false,
        });
    }
}
